(() => {
  const CAROUSEL_CONFIGS = [
    {
      rootSelector: '[data-certificates-carousel]',
      trackSelector: '[data-certificates-track]',
      controlsSelector: '[data-certificates-controls]',
      dotsSelector: '[data-certificates-dots]',
      prevSelector: '[data-certificates-prev]',
      nextSelector: '[data-certificates-next]',
      cardSelector: '.certificate-card',
      pageClass: 'certificates-premium__page'
    },
    {
      rootSelector: '[data-products-carousel]',
      trackSelector: '[data-products-track]',
      controlsSelector: '[data-products-controls]',
      dotsSelector: '[data-products-dots]',
      prevSelector: '[data-products-prev]',
      nextSelector: '[data-products-next]',
      cardSelector: '.cert-product-card',
      pageClass: 'certificates-products__page'
    }
  ];

  const clampPerPage = (value) => {
    const parsed = Number.parseInt(value, 10);
    if (Number.isNaN(parsed)) return 6;
    return Math.min(Math.max(parsed, 1), 6);
  };

  const buildPages = (track, cards, perPage, pageClass) => {
    const fragment = document.createDocumentFragment();

    for (let index = 0; index < cards.length; index += perPage) {
      const page = document.createElement('div');
      page.className = pageClass;

      cards.slice(index, index + perPage).forEach((card) => {
        page.appendChild(card);
      });

      fragment.appendChild(page);
    }

    track.innerHTML = '';
    track.appendChild(fragment);
    return Array.from(track.children);
  };

  const initCarousel = (carousel, config) => {
    if (!carousel || carousel.dataset.carouselReady === 'true') return;

    const track = carousel.querySelector(config.trackSelector);
    const controls = carousel.querySelector(config.controlsSelector);
    const dotsWrap = carousel.querySelector(config.dotsSelector);
    const prevButton = carousel.querySelector(config.prevSelector);
    const nextButton = carousel.querySelector(config.nextSelector);

    if (!track || !controls || !dotsWrap || !prevButton || !nextButton) return;

    const cardSelector = carousel.dataset.cardSelector || config.cardSelector;
    const pageClass = carousel.dataset.pageClass || config.pageClass;
    const cards = Array.from(track.querySelectorAll(cardSelector));
    const perPage = clampPerPage(carousel.dataset.perPage);

    if (cards.length <= perPage) {
      carousel.dataset.carouselReady = 'true';
      return;
    }

    const pages = buildPages(track, cards, perPage, pageClass);
    const dots = [];
    let activeIndex = 0;

    dotsWrap.innerHTML = '';

    const goTo = (nextIndex) => {
      activeIndex = Math.min(Math.max(nextIndex, 0), pages.length - 1);
      track.style.transform = `translateX(-${activeIndex * 100}%)`;

      prevButton.disabled = activeIndex === 0;
      nextButton.disabled = activeIndex === pages.length - 1;

      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    };

    pages.forEach((_, pageIndex) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'certificates-premium__dot';
      dot.setAttribute('aria-label', `Przejdź do strony ${pageIndex + 1}`);
      dot.addEventListener('click', () => goTo(pageIndex));
      dotsWrap.appendChild(dot);
      dots.push(dot);
    });

    prevButton.addEventListener('click', () => goTo(activeIndex - 1));
    nextButton.addEventListener('click', () => goTo(activeIndex + 1));

    controls.hidden = false;
    carousel.classList.add('is-ready');
    carousel.dataset.carouselReady = 'true';

    goTo(0);
  };

  const initAll = (root = document) => {
    CAROUSEL_CONFIGS.forEach((config) => {
      root.querySelectorAll(config.rootSelector).forEach((carousel) => {
        initCarousel(carousel, config);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
